"use client";

import Lottie from "lottie-react";
import CommonSubtitle from "@/components/common/CommonSubtitle";
import multipleToolsAnimation from "@/assets/images/mutliple-tools.json";

const AppScrollArea = () => {
  return (
    <div className="bg-white">
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center">
          <h2 className="mb-2 text-[24px] font-semibold text-[#202020] lg:mb-4 lg:text-[32px]">
            <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
              Tired of Switching
            </span>{" "}
            Multiple Tools?
          </h2>
          <CommonSubtitle
            color="#202020"
            fontSizeWeight="max-w-[900px] mx-auto text-center"
          >
            Stop wasting 40% of your day switching contexts. Kroolo is the
            antidote to app fragmentation.
          </CommonSubtitle>
        </div>
        <div className="h-full w-full" aria-hidden="true">
          <Lottie
            animationData={multipleToolsAnimation}
            loop
            className="h-full w-full object-contain"
          />
        </div>
        <div className="mt-6 text-center">
          <h3 className="mb-2 text-[20px] font-semibold text-[#202020] lg:text-[22px]">
            Replaced by{" "}
            <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
              Kroolo
            </span>
          </h3>
          <CommonSubtitle
            color="#202020"
            fontSizeWeight="max-w-[400px] mx-auto text-center"
          >
            One Subscription. All Features.
          </CommonSubtitle>
        </div>
      </div>
    </div>
  );
};

export default AppScrollArea;
